import { defineComponent } from 'vue'

interface Props {
  tData?: string
  class?: string
}

export default defineComponent((props: Props, context) => {
  return () => (
    <div
      t-data={props.tData}
      class={['inline-block rounded-[100px] px-3 py-1.5 text-caption text-neutral-800', props.class]}
    >
      {context.slots.default?.()}
    </div>
  )
}, {
  name: 'VChip',
  props: ['tData', 'class']
})
